<template>

    <!-- Username -->
    <div v-if="method !== 2" class="col-span-6" :class="!dontShrink ? 'sm:col-span-4' : ''">
        <div>
            <label for="username" class="block text-sm font-medium text-gray-700">Uživatelské jméno</label>
            <div class="mt-1 relative rounded-md shadow-sm">
                <input @input="$emit('update:username', $event.target.value)" :disabled="processing" :value="username" type="text" id="username" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-10 sm:text-sm border-gray-300 rounded-md" placeholder="uživatelské jméno">
            </div>
        </div>
    </div>
    <!-- Databox ID -->
    <div v-if="method === 2" class="col-span-6" :class="!dontShrink ? 'sm:col-span-4' : ''">
        <div>
            <label for="id" class="block text-sm font-medium text-gray-700">ID Datové Schránky</label>
            <div class="mt-1 relative rounded-md shadow-sm">
                <input @input="$emit('update:username', $event.target.value)" :disabled="processing" :value="username" type="text" id="id" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-10 sm:text-sm border-gray-300 rounded-md" placeholder="id datové schránky">
            </div>
        </div>
    </div>

    <!-- Password -->
    <div v-if="method === 0" class="col-span-6" :class="!dontShrink ? 'sm:col-span-4' : ''">
        <div>
            <label for="password" class="block text-sm font-medium text-gray-700">Heslo</label>
            <div class="mt-1 relative rounded-md shadow-sm">
                <input @input="$emit('update:password', $event.target.value)" :disabled="processing" :value="password" type="password" id="password" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-10 sm:text-sm border-gray-300 rounded-md" placeholder="heslo">
            </div>
        </div>
    </div>

    <!-- MK code -->
    <div v-if="method === 4" class="col-span-6" :class="!dontShrink ? 'sm:col-span-4' : ''">
        <div>
            <label for="mkcode" class="block text-sm font-medium text-gray-700">Komunikační kód</label>
            <div class="mt-1 relative rounded-md shadow-sm">
                <input @input="$emit('update:password', $event.target.value)" :disabled="processing" :value="password" type="password" id="mkcode" class="focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-10 sm:text-sm border-gray-300 rounded-md" placeholder="komunikační kód">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ISDSAccountInputs",

    props: {'method': {}, 'processing': {}, 'username': {}, 'password': {},
        dontShrink: {
            type: Boolean,
            default: false,
        }
    },

}
</script>

<style scoped>

</style>
